export default {
    mounted() {
        this.handleKeyup = e => {
            if (e.keyCode === 13) {
                this.handleNext();
            }
        };
        document.addEventListener('keyup', this.handleKeyup);
    },
    unmounted() {
        document.removeEventListener('keyup', this.handleKeyup);
    }
};
